import { Link } from "react-router-dom";
import { hotRanking } from "@/mocks/dramas";

export default function HotRanking() {
  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-1">
              热播排行榜
            </h2>
            <p className="text-sm text-foreground-500">
              全网最热剧集，实时更新排名
            </p>
          </div>
          <Link
            to="/category/remen"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {hotRanking.map((drama) => (
            <Link
              key={drama.id}
              to={`/article/${drama.slug}`}
              className="group flex items-center gap-4 p-3 md:p-4 bg-background-50 rounded-xl hover:bg-background-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="relative flex-shrink-0">
                {drama.rank <= 3 ? (
                  <span
                    className={`absolute -top-1.5 -left-1.5 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold text-background-50 z-10 ${
                      drama.rank === 1
                        ? "bg-accent-500"
                        : drama.rank === 2
                          ? "bg-secondary-500"
                          : "bg-primary-400"
                    }`}
                  >
                    {drama.rank}
                  </span>
                ) : (
                  <span className="absolute -top-1.5 -left-1.5 w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold text-background-50 bg-foreground-400 z-10">
                    {drama.rank}
                  </span>
                )}
                <img
                  src={drama.coverImage}
                  alt={drama.title}
                  className="w-16 h-20 md:w-20 md:h-28 rounded-lg object-cover object-top shadow-sm"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1 flex-wrap">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading truncate">
                    {drama.title}
                  </h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-800 font-medium whitespace-nowrap">
                    {drama.rating}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-1.5 whitespace-nowrap">
                  {drama.year} · {drama.category} · {drama.updateInfo}
                </p>
                <div className="flex items-center gap-1 flex-wrap">
                  {drama.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className="ri-play-line text-sm"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/remen"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部排行
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}